import PropTypes from "prop-types";
import { useProductCollectionContext } from "../../context";
import CollectionListItem from "./CollectionGridListItem";

const ProductCollectionsGridList = () => {
	const { collections } = useProductCollectionContext();
	return (
		<div className="flex flex-col flex-auto shrink-0 w-full collection-product-wrapper">
			<div className="grid gap-x-8 gap-y-4 grid-cols-4 product-wrapper-grid">
				{collections.map((collection) => (
					<CollectionListItem key={collection.id} collection={collection} />
				))}
			</div>
		</div>
	);
};

ProductCollectionsGridList.propTypes = {
	attributes: PropTypes.object,
};

export default ProductCollectionsGridList;
